import { ReactNode } from "react";

// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { UNSAFE_media } from "@atlaskit/primitives/responsive";

import {
    ContentBlock,
    OneButtonProps,
    ButtonAndSecondaryLinkProps
} from "../../../../components/wpl/content-block/src";
import { AspectRatios, Image } from "../../../../components/wpl/image/src";
import {
    Row,
    BGProps,
    BGStyles
} from "../../../../libraries/wpl/foundations/src";

export type ImagePositions = "left" | "right";

export interface PatternHeroProps {
    headerText: ReactNode;
    bodyText: ReactNode;
    imageLink: string;
    imageAltText: string;
    imagePosition?: ImagePositions;
    imageCss?: string;
    className?: string;
    ctaProps?: OneButtonProps | ButtonAndSecondaryLinkProps;
    backgroundProperties?: BGProps;
    aspectRatio?: AspectRatios;
}

const heroStyle = css`
    padding: 80px 0;

    ${UNSAFE_media.only.sm} {
        padding: 60px 0;
    }

    ${UNSAFE_media.below.sm} {
        padding: 40px 0;
    }
`;

export const HeroImageTextSide = ({
    headerText,
    bodyText,
    imageLink,
    imageAltText,
    imagePosition,
    imageCss,
    className = "",
    ctaProps,
    backgroundProperties,
    aspectRatio
}: PatternHeroProps) => {
    return (
        <div
            className={className}
            css={[BGStyles(backgroundProperties), heroStyle]}
        >
            <Row layout="6-6" alignItems="center">
                <ContentBlock
                    headerText={headerText}
                    headerType="h1"
                    bodyText={bodyText}
                    ctaProps={ctaProps}
                />

                <Image
                    src={imageLink}
                    alt={imageAltText}
                    aspectRatio={aspectRatio || "none"}
                    css={css`
                        ${imagePosition == "left" ? `order: -1` : ""}
                        ${imageCss}
                    `}
                />
            </Row>
        </div>
    );
};
